import { TArticleMenuNode } from 'api/contentful/articles'
import { ArticleContentTableItem } from 'components/articles/articleContentTable/ArticleContentTableItem'
import {
  SItemsWrapper,
  SSectionWrapper,
  SSsectionTitleWrapper,
} from 'components/articles/articleContentTable/styled'
import { Icon } from 'components/icon'
import { Text } from 'components/Typography'

export const ArticleContentTableSection = (props: {
  section: TArticleMenuNode
  expanded: boolean
  onSectionToggle: () => void
  onLinkClick: () => void
  order: number
}) => {
  return (
    <SSectionWrapper>
      <SSsectionTitleWrapper onClick={props.onSectionToggle} expanded={props.expanded}>
        <Text variant="bodyBold">{`${props.order}. ${props.section?.title}`}</Text>
        <Icon size="1rem" name="ChevronDown" />
      </SSsectionTitleWrapper>
      <SItemsWrapper expanded={props.expanded}>
        {props.section?.nodesCollection?.items?.map((articleItem) => (
          <ArticleContentTableItem
            key={articleItem?.article?.slug}
            articleItem={articleItem}
            onLinkClick={props.onLinkClick}
          />
        ))}
      </SItemsWrapper>
    </SSectionWrapper>
  )
}
